import axios from "axios";
import { getCookie } from "./utils";
import {
  REACT_APP_STRIPE_PUBLISHABLE_PRODUCTION_KEY_ENC,
  REACT_APP_STRIPE_PUBLISHABLE_STAGING_KEY_ENC,
} from "./constants";
// import {
//   REACT_APP_STRIPE_PUBLISHABLE_PRODUCTION_KEY_ENC,
//   REACT_APP_STRIPE_PUBLISHABLE_STAGING_KEY_ENC,
// } from "./constants";

const configURLS = {
  production: {
    baseURL: "https://api.ogiso.io",
    frontendURL: "https://www.ogiso.io",
    socketURL: "https://websocket.ogiso.io",
  },

  staging: {
      //baseURL: "https://pilot-api.ogiso.io",
    baseURL: "https://staging-api.ogiso.io",
    frontendURL: "https://staging.ogiso.io",
    socketURL: "https://staging-websocket.ogiso.io",
  },

  test: {
    baseURL: "https://staging-api.ogiso.io",
  },

  local: {
    // baseURL: "http://192.168.18.26:5000",
    baseURL: "http://localhost:5000",
    frontendURL: "http://localhost:3000",
    socketURL: "http://localhost:5000",
  },
};

// Points to check before deployment:
// Change Firebase Project
// Change Base URL

// staging, production, local
export const environment = "production";

export const stediUsageIndicator = environment === "production" ? "P" : "T";
export const Essential_Support_Note = "679cae7b2a9d98b98db57c26";
export const Intervention_Progress_Note = "68aefa50f94634ab806524eb";
export const Group_Note = "6a2111b5cb7297bbf6c2ed0b";
export const Billing_Services_Note = "67c03f1744b56dc58c2504bb";
export const PROGRESS_Note =
  environment === "production"
    ? "65af568b51c7a9d2e590030f"
    : "65844ebc60e43ae42de946ff";

export const stripe_publishable_key =
  environment === "production"
    ? REACT_APP_STRIPE_PUBLISHABLE_PRODUCTION_KEY_ENC
    : REACT_APP_STRIPE_PUBLISHABLE_STAGING_KEY_ENC;

export const https = (TOKEN) => {
  const token = getCookie("token");
  return axios.create({
    baseURL: configURLS[environment].baseURL,
    headers: {
      Authorization: `Bearer ${TOKEN || token}`,
    },
  });
};

export const isStaff = (role) => {
  return role?.toLowerCase() === "staff";
};

const baseURL = configURLS[environment].baseURL;
const frontendURL = configURLS[environment].frontendURL;
const socketURL = configURLS[environment].socketURL;
export { baseURL, frontendURL, socketURL };
